import { useMemo } from 'react';
import { Link, useTranslation } from '@weareconceptstudio/core';

//* Style
import ButtonStyle from './style';

const Button = ({
	btnType,
	text,
	className,
	onClick,
	url,
	type = 'button',
	disabled = false,
	children,
	external = false,
	ariaLabel = url,
}) => {
	const { translate } = useTranslation();

	//! Checks
	const Component = useMemo(() => (url ? Link : 'button'), [url]);
	const customProps = useMemo(
		() => (url ? { url, ariaLabel, external } : { type, disabled }),
		[url, external, type, disabled, ariaLabel]
	);

	let btn;

	switch (btnType) {
		default:
			btn = (
				<ButtonStyle
					onClick={onClick || null}
					className={`btn ${btnType || ''} ${className || ''} ${disabled ? 'disabled' : ''}`}>
					<Component {...customProps}>{children || translate(text)}</Component>
				</ButtonStyle>
			);
	}

	return btn;
};

export default Button;
